import axios from "axios";
import UrlHelper from '../Helpers/urlHelper';

class UploadFilesService {

    async getPresignedPostData(competence, files) {
        let data = { competence: competence, files: files.map(function (i) { return { name: i.name } }) };
        let response = await axios.post(UrlHelper.buildUploadUrl(), JSON.stringify(data));
        return response.data;
    }

    async upload(presignedlist, files) {
        for (const file of files) {
            const { presignedData } = presignedlist.data.presigned.filter((i) => i.filename === file.name)[0];
            await this.uploadToS3(presignedData, file);
        }
    }

    async uploadToS3(presignedPostData, file) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            Object.keys(presignedPostData.fields).forEach((key) => {
                formData.append(key, presignedPostData.fields[key]);
            });
            formData.append("file", file);
            axios
                .post(presignedPostData.url, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    if (response.status === 204) {
                        resolve(response);
                    }
                    reject(response.responseText);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}
export default UploadFilesService;